export default "__VITE_ASSET__BhY0MbVM__"